/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum CohortrendementVanafWaarde {
    ZONDER_VERTRAGING = "Zonder vertraging",
    OPGESTROOMD = "Opgestroomd",
    AFGESTROOMD = "Afgestroomd",
    AFGESTROOMD_GEDOUBLEERD = "Afgestroomd & gedoubleerd",
    GEDOUBLEERD = "Gedoubleerd",
    OPGESTROOMD_GEDOUBLEERD = "Opgestroomd & gedoubleerd"
}
